import React from "react";
import { Grid, Tabs, Tab } from "@material-ui/core";
import ChartTitle from "../ChartTitle";
import useStyles from "../Styles";
import userActions from "../actions";
import { useSelector } from "react-redux";
import IrrigationPolygonMap from "./IrrigationPolygonMap";
import CitiesPolygonMap from "./CitiesPolygonMap";
import CurrentCitiesPolygonMap from "./CurrentCitiesPolygonMap";

const PolygonMapView = () => {
  const classes = useStyles();
  // const [tab, setTab] = React.useState("curr_per_capita");
  const {
    // setCentralAZTab,
    setPolygonMapTab,
    // resetSelectedCity,
    // loadCityMetrics,
    // loadEntityEntitlements,
    // loadCityWaterSources,
  } = userActions();
  const { polygon_map_tab } = useSelector((state) => state.technical_view);
  const onChangeTab = (_event, value) => {
    // setTab(value);
    // setCentralAZTab(value);
    setPolygonMapTab(value);
  };

  // useEffect(() => {
    
  //   return () => {
  //     // if (!isMobile) {
  //     //   resetSelectedCity();
  //     //   loadCityMetrics(1);
  //     //   loadEntityEntitlements(1);
  //     //   loadCityWaterSources(1);
  //     // }
  //     // setPolygonMapTab("curr_per_capita");
  //   };
  // }, []);

  return (
    <>
      <div className={classes.polymapView}>
        
          <ChartTitle
            style={{ textAlign: "center" }}
            title={
              polygon_map_tab != null && polygon_map_tab === "curr_per_capita"
                ? "Central Arizona Colorado River Water Access Per Person - Municipal Areas"
                : polygon_map_tab === "per_capita"
                ? "Changes in Access (from 2022) Per Capita - Cities" //Updated Title to be more Accurate
                : "Top Other Water Source"
            }
            subtitle={""}
          />

        {
          <Grid item xs={12} className={classes.tabs} style={{ marginTop: 0 }}>
            <Tabs
              value={polygon_map_tab}
              onChange={onChangeTab}
              classes={{
                root: classes.tabRoot,
                indicator: classes.tabIndicator,
              }}
            >
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value="curr_per_capita"
                label="Colorado River Access Per Person"
                className={classes.startingTab}
              ></Tab>
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value="per_capita"
                label="Changes in Access Per Person"
                className={classes.middleTab}
              ></Tab>
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value="other_sources"
                label="Top Other Water Sources"
                className={classes.endingTab}
              ></Tab>
            </Tabs>
          </Grid>
        }
      </div>
      
      {
        {
          curr_per_capita: <CurrentCitiesPolygonMap />,
          per_capita: <CitiesPolygonMap />,
          other_sources: <IrrigationPolygonMap />,
        }[polygon_map_tab]
      }
    </>
  );
};

export default PolygonMapView;
